import { render } from "./PopupLink.vue?vue&type=template&id=59b73dd4"
import script from "./PopupLink.vue?vue&type=script&lang=js"
export * from "./PopupLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__